export default __webpack_public_path__ + "static/media/resume_ahad.c2fb1b62.pdf";